<mat-card>
  <app-card-header
    icono="place"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (!loading) {
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-card-content
          [class.cardContentDialog]="dialogRef"
          [class.cardContentFullscreen]="!dialogRef && !subtitle"
          [class.cardContentFullscreenSubtitle]="!dialogRef && subtitle"
          class="card-content-crear"
        >
          <!-- Datos -->
          <app-content-card
            title="Datos de la Ubicación"
            icon="place"
            color="blue"
          >
            <section class="inputs-group">
              <!-- Identificación -->
              <mat-form-field style="width: 50%">
                <mat-label>Identificación</mat-label>
                <input matInput formControlName="identificacion" />
                <mat-icon matPrefix>badge</mat-icon>
              </mat-form-field>

              <!-- Color -->
              <mat-form-field style="width: 50%">
                <mat-label>Color</mat-label>
                <input matInput readonly formControlName="color" />
                <mat-icon matPrefix>palette</mat-icon>
                <ngx-colors
                  class="suffix"
                  matSuffix
                  ngx-colors-trigger
                  formControlName="color"
                  (change)="onColorChange($event, 'color')"
                ></ngx-colors>
              </mat-form-field>
            </section>

            <!-- Dirección -->
            <section class="inputs-group">
              <app-autocomplete-direccion
                style="width: 100%"
                [form]="form"
                formControlDireccion="direccion"
                formControlGeoJSON="circleGeoJSON"
                [direccion]="ubicacion?.direccion"
                (geoJSONChange)="centrarA = $event"
              ></app-autocomplete-direccion>
            </section>
          </app-content-card>

          <!-- Mapa -->
          <app-content-card title="Territorio" icon="map" color="orange">
            <app-map-draw-mapbox
              [form]="geojson"
              [tipo]="tipoDibujo"
              [buscadorOsm]="
                tipoDibujo === 'Polygon' || tipoDibujo === 'MultiPolygon'
              "
              (tipoDetectado)="tipoDibujo = $event"
              [centrarA]="centrarA"
              [color]="form.get('color')?.value"
            ></app-map-draw-mapbox>
          </app-content-card>
        </mat-card-content>

        <mat-divider></mat-divider>

        <!-- Botones  -->
        <mat-card-actions class="actions-create">
          <app-button
            matType="mat-fab extended"
            color="neutral"
            (click)="volver()"
            text="Cancelar"
            icon="close"
          ></app-button>
          <app-button
            matType="mat-fab extended"
            [disabled]="!this.form.valid || loading"
            color="primary"
            text="Guardar"
            icon="save"
            type="submit"
          ></app-button>
        </mat-card-actions>
      </form>
    }
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
